module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-crm/03-372de5bd22fa405316d5f703bca75baa.png";